var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0px"}},[_c('img',{staticClass:"imagen",attrs:{"src":require("../assets/img/404-error-not-found-edit.png")}})])}]

export { render, staticRenderFns }